module.exports = __webpack_public_path__ + "img/14-2.f50ba2b7.png";